import { axiosInstance } from '@configs/axios/axiosInstance';

import type {
  DownloadDocumentParams,
  DownloadDocumentResult,
} from './downloadDocument.types';

import { extractFilename } from './downloadDocument.utils';

/**
 * Download a document by ID.
 * Endpoint: GET /documents/{id}
 *
 * Returns the file as a Blob along with the filename parsed from the
 * Content-Disposition response header (null when the header is absent).
 *
 * `organizationId` is sent as X-Organization-ID when provided (Manage module).
 */
export async function downloadDocument(
  params: DownloadDocumentParams
): Promise<DownloadDocumentResult> {
  const headers: Record<string, string> = {
    Accept: 'application/octet-stream',
  };
  if (params.organizationId) {
    headers['X-Organization-ID'] = params.organizationId;
  }

  const response = await axiosInstance.get<Blob>(
    `/documents/${params.documentId}`,
    { responseType: 'blob', headers }
  );

  const contentDisposition = String(
    response.headers['content-disposition'] ?? ''
  );

  return { blob: response.data, filename: extractFilename(contentDisposition) };
}
